module.exports = __webpack_public_path__ + "static/img/bg-fr.c4bd747e.png";